export enum OrderTabs {
  DETAILS = "details",
  PRODUCTS = "products",
  SSCC = "sscc",
  COMMUNICATIONS = "communications",
}
